import { all, put } from 'redux-saga/effects';
import {
  initPostStream,
  initGallectionStream,
  initBrowseStream,
  deselectAll,
  unsetCurrentFolderId,
  unsetSearchQuery,
  unsetSearchInput,
  initTierStream,
  unsetCurrentTierId,
  changeCurrentMediaSource,
  initCommissionStream,
} from '../actions';
import { MediaSourceType } from '../types';
import type { SagaIterator } from 'redux-saga';

export default function* (action: ReturnType<typeof changeCurrentMediaSource>): SagaIterator {
  const { payload } = action;
  if (!payload) {
    return;
  }
  const mediaSource = payload;

  const actionsToPut = [
    deselectAll(),
    unsetCurrentFolderId(),
    unsetCurrentTierId(),
    unsetSearchQuery(),
    unsetSearchInput(),
  ];

  if (
    [
      MediaSourceType.GALLERY,
      MediaSourceType.PRIVATE_COLLECTION,
      MediaSourceType.COLLECTION,
      MediaSourceType.STASH,
    ].includes(mediaSource)
  ) {
    actionsToPut.push(initGallectionStream({}));
  } else if (
    [
      MediaSourceType.POLL,
      MediaSourceType.STATUS,
      MediaSourceType.JOURNAL,
      MediaSourceType.POSTS,
    ].includes(mediaSource)
  ) {
    actionsToPut.push(initPostStream(mediaSource));
  } else if (mediaSource === MediaSourceType.BROWSE) {
    actionsToPut.push(initBrowseStream());
  } else if (mediaSource === MediaSourceType.COMMISSIONS) {
    actionsToPut.push(initCommissionStream());
  } else if (
    [MediaSourceType.TIER, MediaSourceType.TIER_DEVIATIONS, MediaSourceType.TIER_POSTS].includes(
      mediaSource
    )
  ) {
    actionsToPut.push(initTierStream());
  }
  yield all(actionsToPut.map(actionToPut => put(actionToPut)));
}
